/* unplugin-vue-components disabled */import { render } from "./videos.vue?vue&type=template&id=d1ce8850&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"

import "./videos.vue?vue&type=style&index=0&id=d1ce8850&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ce8850"]])

export default __exports__